import { Line } from "rc-progress";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { enrollModal, parentLoginAction, setSubscribeModal, showModal } from "../../redux/actions";
import * as image from "../../resources/images";
import { PATHS } from "../../utils";
import { getAlluserCourses, getLoginType, getSequnceSort } from "../../utils/helper";
import { getCoursesInformation, getRewardData, getSocialActivityDetail } from "../../redux/actions/APIs";
import UserPinPopUp from "../userprofile/UserPinPopUp";

const PlanCards = ({ course, courseIndex, showSelectedCourse, selectedCourse, myplan, handlePlanGoals, isViewPlan, selectChild }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const viewRewardRef = useRef();
    const createRewardRef = useRef();

    const { loggedInUser, defaultChildData, verifyPinResponse, rewardData, parentVerifyResp, parentLogin } = useSelector(
        (state) => state.collections
    );

    const loginType = getLoginType(loggedInUser);

    const [myUserData, setMyUserData] = useState();
    const [courseData, setCourseData] = useState();
    const [isDropDown, setIsDropDown] = useState("");

    const handleContinue = (courseObj) => {
        courseObj.planId = myplan.id;
        dispatch(getSocialActivityDetail())
        dispatch(getCoursesInformation());
        history.push({
            pathname: PATHS.STR_COURSE_DETAIL + "/" + courseObj?.id + "/" + courseObj?.currentModuleId,
            state: { course: courseObj }
        })
    }

    const handleEnroll = (courseIndex) => {
        //  console.log("handleEnroll : ", courseObj);
        let getAllPlanCourse = getAlluserCourses(myplan);
        getAllPlanCourse[0].courseIndex = courseIndex;
        if (loggedInUser?.children?.length > 1) {
            dispatch(showModal({ type: "ChildEnrollmentPopUp", course: getAllPlanCourse, }));
        } else {
            getAllPlanCourse[0].childId = defaultChildData?.id;
            dispatch(enrollModal(getAllPlanCourse));
        }
    }

    const showRewardPopUp = (courseData, rewardType)=>{
        let obj = {
            data: courseData,
            userId: selectChild?.id,
            courseId: selectedCourse?.id,
            type: rewardType ? rewardType : "",				
		};
        dispatch(
            showModal({
                type: "AddReward",
                data: obj,                
            })
        );
    }

    const handleAddReward = (courseObj, rewardType)=>{ 
        if(loggedInUser?.role?.name === "LEARNER") {
            setCourseData(courseObj); 
            let dataObj = loggedInUser?.parent;
            if(loggedInUser?.parent?.isProfilePin){
                dataObj.isPin = true;            
                setMyUserData(dataObj); 
            }else{
                dataObj.isPin = false;
                dispatch(parentLoginAction(true));
            }                
            // console.log('loggedInUser?.parent : ', loggedInUser, loggedInUser?.parent);        
            return false;
        }        
        showRewardPopUp(courseObj, rewardType);
        // console.log("handleAddReward : ", courseObj);            
    }
    //  console.log("PlanCards : ", courseIndex, course, selectedCourse, course?.badges);
    
    const handleUserPinPopUp = (dataObj) => {        
        setMyUserData(dataObj);        
    }

    useEffect(() => {   
        //  console.log('OUT : ');     
        if (myUserData && verifyPinResponse?.records?.length > 0 && verifyPinResponse?.records[0]?.userId || ((parentVerifyResp && parentVerifyResp?.success))) {
            //  console.log('IN');
            setMyUserData(false);
            let rewardType = rewardData?.records?.length > 0 ? "view" : "";
            showRewardPopUp(selectedCourse, rewardType);
        }
    }, [verifyPinResponse, parentVerifyResp]);

    // console.log("parentVerifyResp : ", parentVerifyResp, rewardData, parentLogin);

    const handleViewReward = (courseObj, rewardObj)=>{
        dispatch(getRewardData());
        dispatch(getRewardData(selectChild?.id, rewardObj?.id, true));
        if(loggedInUser?.role?.name === "PARENT"){
            handleAddReward(courseObj, "view");
        }else {
            dispatch(showModal({type: "RewardPopUp", courseObj: courseObj}));
        }
    }

    useEffect(() => {
            const handleClickOutside = (event) => {
                if ((viewRewardRef && viewRewardRef.current && viewRewardRef.current.contains(event.target)) || 
                    (createRewardRef && createRewardRef.current && createRewardRef.current.contains(event.target)) ) {
                    // console.log("handleClik Insise ##");
                } else {
                    // console.log("handleClik outSide #", event.target, viewRewardRef);
                    setIsDropDown();
                }
            };
            document.addEventListener("click", handleClickOutside);
            return () => {
                document.removeEventListener("click", handleClickOutside);
            };
        }, []);

   

    return (
        <>
        <div className={`coursecard ${course?.dimesnion?.name}DimCard ${(!myplan?.isRecommendedPlan || (myplan?.isRecommendedPlan && isViewPlan)) && course?.id === selectedCourse?.id  ? "Active_running_course" : ""} `}
            key={courseIndex}
            onClick={() => showSelectedCourse(course)} >

            <div className="skils_dimName" >
                <div className="flexone">
                    <ul className="flextwo">
                        <li   
                            className="flexfive"><span><img src={image.dimension_white} alt="Dimension_icon" /></span>{course?.dimesnion?.name}</li>
                        <li className="flexfive"><span><img src={image.skillsnewicon} alt="skillicon" /> </span>{course?.skill?.name}</li>
                    </ul>
                          <div className="ml-3 mypoints flexthree align-items-center position-relative">
                        <span className="mr-2 achivedreward flexthree" 
                            ref={viewRewardRef}
                            onClick={() =>  setIsDropDown("viewDropDown")} 
                            data-toggle="collapse"
                            href={`#rewarMydDrop`}
                            aria-expanded={course?.id === selectedCourse?.id}
                        >
                            <img src={image.rewardicon} alt="pointbag" />
                            <span className="pointsno p1">{course?.rewards?.length}</span>
                            {isDropDown === "viewDropDown" && course?.id === selectedCourse?.id && course?.rewards?.length > 0 && (
                                 <div className="panel-collapse collapse planname_list" 
                                aria-labelledby={`rewarMydDropDwon${course.id}`}
                                id={`rewarMydDrop`}>
                                 <div className="mytoottiptxt p-3" 
                                    > 
                            {course?.rewards?.length > 0 && 
                            getSequnceSort(course?.rewards)?.map((currentReward, index)=>(                                
                                    <div 
                                        className="flexthree showreward_list" 
                                        key ={index}
                                        onClick={() => handleViewReward(course, currentReward)}
                                    >
                                        <div className="rewarding pointer" 
                                        
                                        >
                                        <img src={currentReward?.imageUrl ? currentReward?.imageUrl : image.reward_icon} className="mr-2" alt="rewardbadges" />
                                        </div>
                                        <div className="pointer">
                                        <p className="p1 fw-700">{currentReward?.title}</p>
                                        <p className="p2">{currentReward?.targetPoint}</p>
                                        </div>
                                    </div>                                    
                            ))}
                            </div>
                            {/* {(() => {
                            const currentReward = course?.rewards?.find(reward => !reward?.isCompleted);
                                // console.log("currentReward : ", currentReward, course);
                                if (!currentReward) return null;

                                return (
                                    <div className="mytoottiptxt p-3" 
                                        onClick={() => handleViewReward(course, currentReward)}
                                    >  
                                    <div className="flexthree">
                                        <div className="rewarding" 
                                        
                                        >
                                        <img src={currentReward?.imageUrl ? currentReward?.imageUrl : image.reward_icon} className="mr-2" alt="rewardbadges" />
                                        </div>
                                        <div>
                                        <p className="p1 fw-700">{currentReward?.title}</p>
                                        <p className="p2">{currentReward?.targetPoint}</p>
                                        </div>
                                    </div>
                                    </div>
                                );
                            })()} */}
                        </div>
                            )}
                           
                        </span>
                           
                         <span className=" flexthree">
                        <img src={image.point_bag} alt="pointbag" />
                        <span className="pointsno p1">{course?.userPoint ? course?.userPoint : 0}</span>
                        </span>
                        <span 
                             ref={createRewardRef}
                            onClick={() =>  setIsDropDown("createDropDown")} 
                            className="addrewardmenu pl-3 pointer"
                           
                            data-toggle="collapse"
                           
                            href={`#rewarMydDropDwon${course.id}`}

                            aria-expanded="false"    
                        >
                        <i class="fa-light fa-ellipsis-vertical"></i>
                        {!myplan?.isRecommendedPlan && isDropDown === "createDropDown" && (
                               <ul className="panel-collapse collapse planname_list" 
                            aria-labelledby={`rewarMydDropDwon${course.id}`}
                             id={`rewarMydDropDwon${course.id}`}

                        >
                         <li 
                            className={`${(course?.isCompleted || course?.rewards?.some((item)=> !item?.isCompleted && !item?.isExpired)) && "disabledevent" }`} 
                            onClick={()=>{(course?.isCompleted || course?.rewards?.some((item)=> !item?.isCompleted && !item?.isExpired)) ? "" : handleAddReward(course)}}><p class="p2"><img src={image.rewardbadges} 
                            className={`mr-2`} alt="badges"/>
                                Add Reward
                            </p>
                        </li>
                         {/* <li><p class="p2"><img src={image.peopleconnect} className="mr-2"  alt="badges"/>Connect With Soma On This Topic</p></li>
                         <li><p class="p2"><img src={image.whatlearned} className="mr-2" alt="badges"/>See What Sam Learned</p></li> */}
                        
                     </ul>
                        )}
                     
                        </span>
                    </div>
                   
                  
                </div>
            </div>
            <div className="course_name pb-0">
                <h3>{course?.name}</h3>
                <div className="text-right coursebadgelist flex align-items-end">
                    <ul class="ml-auto">
                        {getSequnceSort(course?.badges)?.map((badges, index) => (
                            (!badges?.isLock || myplan?.isRecommendedPlan) && (
                                <li key={index} class="opacitydwn">
                                    <img src={badges?.imageUrl} alt="badgesicon" class="icon" />
                                    	<div className="mytoottiptxt p-3">
                                        <div className="flexthree">
                                        <div className="badges_image">
                                            <img src={badges?.imageUrl}  alt="badges"/>
                                         </div>
                                         <div className="badgesbridedesc ml-3 mt-3">
											<h2 className=" fw-500 mb-2"> {badges.badgesName}</h2>
                                            {console.log(badges,"badges")}
										     <p className="">{badges?.description}</p>
                                               {/* <p className="">
                                               The Raven reads between the lines. It guides you to trust the quiet truths inside you.
                                               </p>
                                               <p>
                                               Earn this badge by completing module 3 of this course.
                                                 </p> */}
                                             </div>
										</div>
                                        </div>
                                </li>
                            )
                        ))}
                    </ul>
                    <span className="badgescount ml-1">{course?.badges?.length > 0 ? course?.badges?.filter(obj => obj.isLock !== true || myplan?.isRecommendedPlan).length : 0}/4</span>
                </div>
                <div className="course_progress">
                    {/* 🥳🎉🤩🎊 */}
                    <p className="p3 textuppercase">
                        <span className="mr-1">{course?.courseModCompletion ? course?.courseModCompletion : 0}%</span> progress
                        <span className="ml-1">
                            {course?.courseModCompletion >= 25 && course?.courseModCompletion < 50 ? '🎉' : ''}
                            {course?.courseModCompletion >= 50 && course?.courseModCompletion < 75 ? '🤩' : ''}
                            {course?.courseModCompletion >= 75 && course?.courseModCompletion < 100 ? '🥳' : ''}
                            {course?.courseModCompletion >= 100 ? '🎊🥳🤩🎉' : ''}
                        </span>
                    </p>
                    <Line percent={course?.courseModCompletion ? course?.courseModCompletion : 0} strokeWidth={10} strokeColor="#FF9900" />
                </div>
                <div className="coursecard_footer flexone">
                    <div className="module_count">
                        <p className="p3 textuppercase">
                        <span className="counting">{course?.completedModule ? course?.completedModule : 0} / {course?.totalModule ? course?.totalModule : 4} </span>Modules complete</p>
                    </div>
                    <div className="Continue_reading">
                        {myplan?.isRecommendedPlan ? (
                            // <p className="p1 flextwo" onClick={() => handleEnroll(courseIndex)}>
                            //     <a href="javascript:void(0)">Start Learning <i class="fa-solid fa-arrow-right-long ml-3"></i></a>
                            // </p>
                            <p className="p1 flextwo" onClick={() => showSelectedCourse(course)}>
                                <a href="javascript:void(0)">View More <i class="fa-solid fa-arrow-right-long ml-3"></i></a>
                            </p>
                        ) : (
                            <>
                                {
                                !loginType && !course?.isComic && !course?.isDefinedGoal && !course?.isCompleted ? (
                                    <p className="p1 flextwo" onClick={() => handlePlanGoals(courseIndex)}>
                                        <a href="javascript:void(0)">Set Goals <i class="fa-solid fa-arrow-right-long ml-3"></i></a>
                                    </p>
                                ) : course?.courseModCompletion < 100 ? (
                                    <p className="p1 flextwo" onClick={() => handleContinue(course)}>
                                        <a href="javascript:void(0)">Continue Learning <i class="fa-solid fa-arrow-right-long ml-3"></i></a>
                                    </p>
                                ) : (<p className="p1 completedcourse flextwo" onClick={() => handleContinue(course)}>
                                        <a href="javascript:void(0)">Completed  <i class="fa-regular fa-badge-check ml-2 pl-1"></i></a>
                                    </p>)
                                }
                            </>                            
                        )}
                       
                    </div>
                </div>
            </div>
        </div>
        {myUserData && myUserData?.isUserPlan && (
            <UserPinPopUp handleUserPinPopUp={handleUserPinPopUp}
                userData={myUserData}
            />
		)}
        </>    
    );
}
export default PlanCards